import CustomDownloadComponent from '../../../components/FileDownload/CustomDownloadComponent';
import UploadedDocuments from '../../../components/UploadedDocuments/Uploaded Documents';
import { UploadedDocumentData } from '../../NewFlooringApplication/UserData';

const DisbursementDetails = ({ ApplicationData, GetOwnerType }) => {
  const AddLabelToFile = (arr, value) => {
    console.log('Document', value);
    return {
      label: value,
      files: arr,
    };
  };
  const temp = ApplicationData?.cart?.filter(
    (it) => it?.agent?.disbursement !== undefined
  );
  const DisbursemnetData = temp?.length > 0 ? temp[0]?.agent?.disbursement : {};
  console.log('DisbursemnetData', DisbursemnetData);

  return (
    <section>
      {/* Application Preview */}
      <div className='preview-list-block'>
        <div className='preview-list-group'>
          <div className='preview-list'>
            <h3>Floor Start Date:</h3>
            <p>{DisbursemnetData?.flooring_start_date}</p>
          </div>
          <div className='preview-list'>
            <h3>Disbursement Date:</h3>
            <p>{DisbursemnetData?.disbursement_date}</p>
          </div>
          <div className='preview-list'>
            <h3>Remarks:</h3>
            <p>{DisbursemnetData?.remarks}</p>
          </div>
        </div>
      </div>

      {/* Uploaded Documents */}
      <div className='preview-list-block'>
        <div className='download-block'>
          <h2 className='preview-subheading'>Document (s) Uploaded</h2>
          <CustomDownloadComponent
            type='Flooring-Disbursement-Details'
            appId={ApplicationData?.vehicleInfo?.id}
            formType={'disbursement_doc'}
          />
        </div>
        <div className='preview-list-group'>
          {ApplicationData?.disbursement_doc?.length > 0 && (
            <UploadedDocuments
              documents={AddLabelToFile(
                ApplicationData?.disbursement_doc,
                'Disbursement Document(s)'
              )}
            />
          )}
        </div>
      </div>
    </section>
  );
};
export default DisbursementDetails;
